import {Injectable} from "@angular/core";
import {BehaviorSubject} from "rxjs";
import {INavigationItems, INavigationType} from "./navigation.interface";

@Injectable()
export class NavigationInteractionsService {
  hasChanges: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  navigationItems: BehaviorSubject<INavigationType[]> = new BehaviorSubject<INavigationType[]>([]);
  allTypeItems: BehaviorSubject<INavigationItems> = new BehaviorSubject<INavigationItems>({});

  constructor() {
  }


  deleteNavigationItem(tempId: number) {
    const data = this.navigationItems.getValue();
    const deleted = this.deleteElementByTempIdRecursive(data, tempId);
    if (deleted) {
      this.navigationItems.next([...data]);
    }
  }

  private deleteElementByTempIdRecursive(data: INavigationType[], tempId: number): boolean {
    for (let i = 0; i < data.length; i++) {
      if (data[i].temp_id === tempId || data[i].id === tempId) {
        data.splice(i, 1);
        return true;
      }
      if (data[i].children && this.deleteElementByTempIdRecursive(data[i].children, tempId)) {
        return true;
      }
    }
    return false;
  }

  editNavigationItem(newData: INavigationType, id: number): boolean {
    const data = this.navigationItems.getValue();
    const edited = this.editElementByTempIdRecursive(data, id, newData);
    if (edited) {
      this.navigationItems.next([...data]);
    }
    return edited;
  }

  private editElementByTempIdRecursive(data: INavigationType[], tempId: number, newData: INavigationType): boolean {
    for (let i = 0; i < data.length; i++) {
      if (data[i].temp_id === tempId) {
        data[i] = newData;
        return true;
      }
      if (data[i].children && this.editElementByTempIdRecursive(data[i].children, tempId, newData)) {
        return true;
      }
    }
    return false;
  }

  transformForRequestArray(localArray) {
    const transformedArray = [];
    localArray.forEach((item) => {

      const category = item.object_id ? this.findElementByObjectId(+item.object_id, this.allTypeItems.value, item.object_type) : {};
      const transformedItem = {
        ...item,
        title: item.title,
        type: category.type || 'custom',
        object_type: item.object_type,
        object_id: item.object_id,
        special_status: category.special_status,
        children: this.transformForRequestArray(item.children || []),
      };
      transformedArray.push(transformedItem);
    });

    return transformedArray;
  }

  transformToLocal(backendArray) {
    const transformedArray = [];

    backendArray.forEach((item) => {
      const transformedItem = {
        id: item.id,
        title: item.title,
        type: item.type || 'custom',
        object_type: item.object_type,
        object_id: item.object_id,
        special_status: item.special_status,
        url: item.url,
        children: this.transformToLocal(item.children || []),
      };

      transformedArray.push(transformedItem);
    });

    return transformedArray;
  }

  private findElementByObjectId(objectId: number, data: any, objectType: string): any | null {
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        const foundElement = data[key].find((element) => element.object_id === objectId && element.object_type === objectType);

        if (foundElement) {
          return foundElement;
        }
      }
    }

    return {};
  }

  checkLayer(item: INavigationType): string {
    if (item.children.length) {
      if (item.children.some(it => !!it.children.length)) {
        return '3';
      }
      return '2';
    }
    return '1';
  }

}
